import { DictionariesService } from "@sa/rep-mdm";
import { uniq } from "../../../../../shared";
import { SLIDE_NUMBER } from "../constants";

export type Parameters = {
  calendar: number[];
  businessUnits: number;
  countries: number[];
  commodities: number[];
  attributes: number[];
  units: number[];
  orderedCommodities: number[];
  displayCommodities: number[];
  comments: string[];
};

export async function getDefaultMark(dictionariesService: DictionariesService, parameters: Parameters) {
  parameters['countries'] = [parameters['businessUnits'] === 2 ? 20000 : 100231];
  const dictSlideCommodities = await dictionariesService.getDictionary({
    id: 'slides-commodities-display',
    parameters: {
      'slide': SLIDE_NUMBER,
      'business_unit': parameters['businessUnits']
    }
  });
  const itemsSlideCommodities = await dictSlideCommodities.getAll();
  parameters['commodities'] = itemsSlideCommodities.map(x => x.getValue<number>('olap_commodity')!);
  parameters['displayCommodities'] = itemsSlideCommodities.map(x => x.getValue<number>('id')!);
  
  parameters['orderedCommodities'] = itemsSlideCommodities.sort((a, b) => {
    const orderIndexA = a.getValue<number>("order")!;
    const orderIndexB = b.getValue<number>("order")!;
    return orderIndexA - orderIndexB;
  }).map(x => x.getValue<number>('olap_commodity')!);
  parameters.comments = itemsSlideCommodities.filter(x => Boolean(x.getValue<string>('comment'))).map(x => {
    try {
      const name = x.getLocalizedValue('name', 9);
      const comment = x.getValue<string>('comment');
      return `${name} = ${comment}`;
    } catch (e) {
      return '';
    }
  }).filter(Boolean);

  
  const calendarDict = await dictionariesService.getDictionary({
    id: 'slides-f-last-calendar',
    parameters: {
      slide: SLIDE_NUMBER,
      attributes: (parameters['attributes'] as number[]).join(','),
      countries: (parameters['countries'] as number[]).join(','),
      commodities: (parameters['commodities'] as number[]).join(','),
      units: (parameters['units'] as number[]).join(','),
    },
  });
  const calendarItems = await calendarDict.getAll();
  const lastYear = uniq(calendarItems.map(item => Number(item.id)))[0];
  const YEAR_STEP = 10000;
  parameters['calendar'] = [-3, -2, -1, 0].map(x => lastYear + (x * YEAR_STEP));
  return parameters;  
}